import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import dayjs from 'dayjs';
export var getStoreTypeFromBrand = function getStoreTypeFromBrand(brand) {
  switch (brand) {
    case "Sainsbury's":
      return 1;

    case 'Habitat':
      return 2;

    default:
      return 0;
  }
};
export var formatTimes = function formatTimes(timetable) {
  var sorter = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };
  return Object.keys(timetable).map(function (day) {
    return {
      date: day.charAt(0).toUpperCase() + day.slice(1),
      time: timetable[day].length > 0 ? "".concat(timetable[day][0].open, " - ").concat(timetable[day][0].close) : ''
    };
  }).sort(function (compareA, compareB) {
    return sorter[compareA.date.toLowerCase()] - sorter[compareB.date.toLowerCase()];
  });
};
export var formatCoordinates = function formatCoordinates(location) {
  return {
    lat: parseFloat(location.latitude),
    lng: parseFloat(location.longitude)
  };
};
export var formatLocation = function formatLocation(store) {
  return _objectSpread({
    address: store.address_line[0],
    town: store.town,
    postcode: store.postcode
  }, formatCoordinates(store.location));
};
export var formatStore = function formatStore(store) {
  var timetable = store.timetable.defaultWeek;
  return {
    id: store.store_id,
    name: store.legacy_name,
    type: getStoreTypeFromBrand(store.brand),
    clickandcollect: store.locator_settings.storeprepay === 6,
    clickAndCollectLocation: store.click_and_collect_location,
    location: formatLocation(store),
    alert: store.emergency_statement === '' || store.emergency_statement === undefined ? null : store.emergency_statement,
    contact: store.phonebook[0].number,
    times: formatTimes(timetable)
  };
};
export var organiseProducts = function organiseProducts(products) {
  var organised = [];
  products.forEach(function (product) {
    if (!organised[product.leadtime.text]) {
      organised[product.leadtime.text] = [];
    }

    organised[product.leadtime.text].push(product);
  });
  return organised;
};
export var filterMap = {
  ANYTIME: null,
  TODAY: 2,
  TOMORROW: 3,
  NOW: 4,
  FUTURE: 5
};
export var createFilters = function createFilters(products) {
  var filters = products.reduce(function (newFilter, product) {
    if (product.customerAvailableBy) {
      var requested = dayjs(product.requested);
      var customerAvailableBy = dayjs(product.customerAvailableBy);

      if (customerAvailableBy.date() === requested.date() && customerAvailableBy.month() === requested.month()) {
        newFilter.push(filterMap.TODAY, filterMap.TOMORROW);
      }

      if (customerAvailableBy.date() === requested.add(1, 'day').date()) {
        newFilter.push(filterMap.TOMORROW);
      }
    }

    return newFilter;
  }, [filterMap.ANYTIME]);
  return {
    filters: Array.from(new Set([].concat(filters)))
  };
};
export var hasAvailabilityCheck = function hasAvailabilityCheck(availability) {
  return availability && availability.every(function (storeAvailability) {
    return storeAvailability.products.reduce(function (total, product) {
      return total + product.stockedQuantity;
    }, 0) === 0;
  });
};
export var filterAvailability = function filterAvailability(availability, activeFilter) {
  if (!availability) return [];
  return availability.reduce(function (filtered, storeAvailability) {
    if (storeAvailability) {
      if (activeFilter.id === null || storeAvailability.availability.filters.includes(activeFilter.id)) {
        filtered.push(storeAvailability);
      }
    }

    return filtered;
  }, []);
};
export var formatProductForAnalytics = function formatProductForAnalytics(product) {
  return {
    id: product.sku,
    leadtimeMessage: product.leadtime.text,
    leadtimeCode: product.leadtime.analyticsCode
  };
};
export var formatAvailabilityForAnalytics = function formatAvailabilityForAnalytics(availability) {
  var items = availability.products.map(formatProductForAnalytics);
  return {
    id: availability.storeId,
    leadtimeMessage: availability.availability.text,
    item: items
  };
};

var parseSkuQty = function parseSkuQty(skuQty) {
  var skuQtySplit = skuQty.split(',');
  return skuQtySplit.map(function (sku) {
    var splitSku = sku.split('_');
    return {
      sku: splitSku[0],
      qty: splitSku[1]
    };
  });
};

var areNationwideSearchableSkus = function areNationwideSearchableSkus(skuQtyParam) {
  var skuQtyList = parseSkuQty(skuQtyParam);
  return skuQtyList.every(function (skuQty) {
    return skuQty.qty === '1' && !skuQty.sku.startsWith('tuc');
  });
};
/*
Check whether to display get more availability feature (aka 'Tell me where' button)
Only show if:
  - stockFinderEnabled prop passed in is true
  - all stores returned are out of stock
  - safe mode configuration from AO is not set to disabled
  - requested skus only have a quantity of one
  - requested skus does not contain a TU product
*/


export var showMoreAvailability = function showMoreAvailability(stockFinderEnabled, allResultsOutOfStock, safeMode, skuQty) {
  return stockFinderEnabled && allResultsOutOfStock && (safeMode === null || safeMode === void 0 ? void 0 : safeMode.stockCheckDisabled) === false && areNationwideSearchableSkus(skuQty);
};